import react.RBuilder
import react.RComponent
import react.RProps
import react.RState
import react.dom.*

external interface AboutUsProps : RProps {

}


@JsExport
class AboutUs(props: AboutUsProps) : RComponent<AboutUsProps, RState>(props) {

    override fun RBuilder.render() {
        div("aboutUs") {
            attrs{
                jsStyle = kotlinext.js.js {
                    textAlign = "center"
                }
            }
            h3{
                +"经方派是专注于经方学习、经方交流、经方研究的网站，致力于利用信息技术为当代经方人学习经方、使用经方提供便利和支持。"
            }
            img{
                attrs{
                    src = "${urlBase}/images/mp_jfp.jpeg"
                }
            }
            p{
                +"本站正在紧张建设中，扫码关注我们，您将在第一时间收到我们的上线通知"
            }
            p{
                +"如您有任何建议，也欢迎通过公众号向我们反馈，我们将会认真考虑每一项建议。"
            }
        }
    }
}
